import { render, staticRenderFns } from "./AuthorCardProfile.vue?vue&type=template&id=048c2645&scoped=true&"
import script from "./AuthorCardProfile.vue?vue&type=script&lang=ts&"
export * from "./AuthorCardProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorCardProfile.vue?vue&type=style&index=0&id=048c2645&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c2645",
  null
  
)

export default component.exports